import './style/global.less';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Button, ConfigProvider, Modal } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import 'animate.css';
import PageLayout from '@/layout/index';
import { GlobalContext } from './context';
import Login from './pages/login';
import changeTheme from './utils/changeTheme';
import useStorage from './utils/useStorage';
import { observer } from 'mobx-react-lite';
import 'virtual:windi.css';
import { appStore, userStore } from './mobx';
import UpgradeModal from './components/UpgradeModal';
import { getUserInfo } from './api/modules/user';

// const store = createStore(rootReducer);

const Index = observer(() => {
  const [lang, setLang] = useStorage('arco-lang', 'zh-CN');
  const [theme, setTheme] = useStorage('arco-theme', 'light');

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return zhCN;
    }
  }

  useEffect(() => {
    console.log(userStore.isHydrated, appStore.isHydrated);
    const search: any = new URLSearchParams(location.search);
    const token = search.get('token');
    console.log('token=======>', token);

    if (userStore.isHydrated) {
      if (localStorage.getItem('Token') || token) {
        userStore.getUserInfo();
      } else if (window.location.pathname.replace(/\//g, '') !== 'login') {
        window.location.pathname = '/login';
      }
    }

    if (appStore.isHydrated) {
      appStore.getConfig();
    }
  }, [userStore.isHydrated, appStore.isHydrated]);

  useEffect(() => {
    changeTheme(theme);
  }, [theme]);

  const contextValue = {
    lang,
    setLang,
    theme,
    setTheme,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <GlobalContext.Provider value={contextValue}>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/" component={PageLayout} />
          </Switch>
        </GlobalContext.Provider>
      </ConfigProvider>

      <UpgradeModal />
    </BrowserRouter>
  );
});

ReactDOM.createRoot(document.getElementById('root')).render(<Index />);
